<template lang="pug">
    d2-container
        el-form(:inline='true', :model='dataForm'  size='mini' label-width="72px" label-position='left' :modal-append-to-body='false'  label-suffix=':' )
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label="姓名" )
                    el-input.inputWidth(v-model='dataForm.name' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="账号" )
                    el-input.inputWidth(v-model='dataForm.mobile' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="状态" )
                    el-select(style='width:100%;'  v-model="dataForm.status" clearable)
                        el-option(v-for="item in statusArr" :key="item.value" :label="item.label" :value="item.value")
        el-row(style="padding-bottom:15px;" :span="24")
            el-col(:md='23' :sm="5")
                el-button(@click='addOrUpdateHandle()'  type='primary' v-if="isAuth('pb:coupon:save')" ) 新建
            el-col( :md='1' :sm="14" style='float:right;')
                el-button(@click='queryList()',type='primary',icon='el-icon-search',style='float:right;') 查 询
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border @selection-change='selectionChangeHandle')
            el-table-column(prop='name',header-align='center',align='center',label='姓名')
            el-table-column(prop='mobile',header-align='center',align='center',label='账号')
            el-table-column(prop='code',header-align='center',align='center',label='代金券编号')
            el-table-column(prop='typeName',header-align='center',align='center',label='代金券类型')
            el-table-column(prop='rangeName',header-align='center',align='center',label='使用范围')
            el-table-column(prop='endTime',header-align='center',align='center',label='有效期')
            el-table-column(prop='remark',header-align='center',align='center',label='备注' :show-overflow-tooltip='true')
            el-table-column(prop='statusName',header-align='center',align='center',label='状态' )
            el-table-column(header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" @click="addOrUpdateHandle(scope.row.id,1)"  type="text" v-if="isAuth('pb:coupon:update')" ) 修改
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        //- 添加和修改
        addOrUpdate(v-if='addOrUpdateVisible', ref="addOrUpdate",@refreshDataList='getDataList')
</template>

<script>
import AddOrUpdate from './add-or-update'

export default {
  name: 'single',
  data () {
    return {
      dialogFormVisible: false,
      isCollapse: true,
      loading: null,
      addOrUpdateVisible: false,
      selChangeData: [],
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataForm: {
        name: '',
        mobile: '',
        status: null
      },
      rangeeArr: [
        { label: '分级单次培训', value: '1' },
        { label: '分级整期培训', value: '2' },
        { label: '青少年儿童培训', value: '3' },
        { label: '定制化培训', value: '4' }
      ],
      statusArr: [
        { label: '未使用', value: 0 },
        { label: '已使用', value: 1 },
        { label: '已失效', value: 2 }
      ]
    }
  },
  components: {
    AddOrUpdate
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    queryList () {
      this.pageIndex = 1
      this.getDataList()
    },
    //添加或修改事件
    addOrUpdateHandle (id, flagType) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, flagType)
      })
    },
    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/pbCoupon/list'),
        method: 'post',
        params: this.$http.adornParams({
          page: this.pageIndex,
          rows: this.pageSize,
          name: this.dataForm.name,
          mobile: this.dataForm.mobile,
          status: this.dataForm.status
        })
      }).then(data => {
        if (data && data.code === 0) {
          this.tableData = data.page.rows
          this.totalPage = data.page.total
          let rangeArr = { '1': '分级单次培训', '2': '分级整期培训', '3': '青少年儿童培训', '4': '定制化培训' }
          let typeArr = { '1': '补课券','2': '代金券' }
          this.tableData.forEach(e => {
            let rArr = e.rangee.split(',')
            let rangeNameArr = []
            rArr.forEach(b => {
              rangeNameArr.push(rangeArr[b])
            })
            e.rangeName = rangeNameArr.join(',')
            e.typeName = typeArr[e.type]
          })
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    //勾选列表事件
    selectionChangeHandle (val) {
      this.selChangeData = val
    }
  }
}
</script>
<style >
/* 操作三点 菜单样式 */
@import "../../css/opr3dot.css";

.inputWidth {
  width: 200px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}

/* 提示框 */
.el-tooltip__popper.is-light {
  border: 1px solid #c0c4cc;
}

.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: grey !important ;
}

.toolTip > p {
  margin: 0;
  padding-top: 10px;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  color: #606266;
}

.el-dialog {
    position: relative;
    margin: 0 auto 80px;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 50%;
}
</style>
